module.exports = __webpack_public_path__ + "media/message 6.0944231d.mp3";